import React from 'react';
import AdminWebAPIUtils from 'utils/AdminWebAPIUtils';
import queryString from 'qs';
import CargomaticInput from 'components/v2/input';
import WhiteLabel from 'utils/whitelabel.js';
import zxcvbn from 'zxcvbn';
import PasswordComplexity from '../../v2/password-complexity';
class PasswordReset extends React.Component {
    constructor(props) {
        super(props);
        this.componentDidMount = async () => {
            var _a;
            try {
                const logo = await WhiteLabel.getClientLogo();
                this.setState({ logo });
                let pathUrl = (_a = this.props.match) === null || _a === void 0 ? void 0 : _a.url;
                if (pathUrl === '/createpassword') {
                    this.setState({ createPassword: true });
                }
            }
            catch (e) {
                console.error('login, failed to get signed URL: ', e);
            }
        };
        this.handlePasswordReset = () => {
            const query = queryString.parse(this.props.location.search, {
                ignoreQueryPrefix: true,
            });
            AdminWebAPIUtils.resetPassword(query.token, this.state.newPassword, this.state.createPassword);
            this.setState({ error: 'Password Changed Successfully!' });
            this.props.history.push('/login');
        };
        this.handleConfirmNewPassword = (value) => {
            this.setState({ confirmPassword: value }, () => {
                this._validateInput();
            });
        };
        this.handleNewPassword = (value) => {
            this.setState({ newPassword: value }, () => {
                this._validateInput();
            });
        };
        this.state = {
            newPassword: '',
            confirmPassword: '',
            valid: false,
            error: null,
            logo: '',
            createPassword: false
        };
    }
    _validateInput() {
        var _a;
        let error;
        let valid = false;
        const blacklist = ['secret', 'cargo1', 'cargo01', 'welcome1', 'cargomatic'];
        const { score } = zxcvbn((_a = this.state) === null || _a === void 0 ? void 0 : _a.newPassword);
        if (this.state.newPassword === this.state.confirmPassword) {
            if (this.state.newPassword.length < 6) {
                error = 'Your password must be at least 6 characters';
            }
            else if (blacklist.indexOf(this.state.newPassword.toLowerCase()) > -1 ||
                score < 2) {
                error = 'Sorry, your password is too weak!';
            }
            else {
                error = null;
                valid = true;
            }
        }
        else {
            error = 'Your passwords must match!';
        }
        this.setState({ valid, error });
    }
    renderPasswordReset() {
        const { newPassword, confirmPassword, error } = this.state;
        return (React.createElement("div", { className: "login-wrapper" },
            React.createElement("div", { className: "login-container" },
                React.createElement("div", { className: "logo" },
                    React.createElement("a", { target: "blank", href: "https://cargomatic.com" },
                        React.createElement("img", { alt: "Cargomatic", src: this.state.logo, style: { height: 30 } }))),
                React.createElement("div", { className: "mb-6 -mt-8" },
                    React.createElement("h4", { className: "mb-2 font-medium text-gray-900" }, "Password Requirements"),
                    React.createElement("ul", { className: "px-6 text-gray-500 list-disc space-y-1" },
                        React.createElement("li", { key: "characters" }, "Password must be at least 6 characters"),
                        React.createElement("li", { key: "match" }, "Use at least 1 symbol, 1 number, and upper and lower case letters"),
                        React.createElement("li", { key: "match" }, "Password complexity must be at least \"fair\""),
                        React.createElement("li", { key: "match" }, "Passwords must match"))),
                !!newPassword.length && (React.createElement(PasswordComplexity, { password: newPassword })),
                React.createElement("div", { className: "mb-2" },
                    React.createElement(CargomaticInput, { value: newPassword, label: "New Password", info: "Please enter a new password", onChange: this.handleNewPassword, name: "new_password", type: "password" })),
                React.createElement("div", { className: "mb-2" },
                    React.createElement(CargomaticInput, { value: confirmPassword, label: "Confirm Password", info: "Please confirm your password", onChange: this.handleConfirmNewPassword, name: "confirm_password", type: "password" })),
                React.createElement("div", null,
                    React.createElement("button", { className: "flex items-center mr-5 text-white login-button button button-green w-35", onClick: this.handlePasswordReset, disabled: !this.state.valid },
                        this.state.createPassword ? 'Create' : 'Reset',
                        " Password")),
                React.createElement("div", { className: "link-container" }, error && React.createElement("p", { className: "text-red-500" }, error)))));
    }
    render() {
        return React.createElement("div", null, this.renderPasswordReset());
    }
}
export default PasswordReset;
